import { Site } from "../site";

Site.initializeFoundation();

$(document).ready(function() {
  const faqSection = $(".homepage-faq-items");

  if (faqSection) {
    $(".homepage-faq-items .faq-item").click(function() {
      $(this).toggleClass("open");

      $(this)
        .siblings(".faq-item.open")
        .each(function() {
          $(this).removeClass("open");
        });
    });

    $(".homepage-faq-items .faq-item").first().addClass("open");
  }
});
